module.exports = __webpack_public_path__ + "img/footer_02_gov24.fe220ef1.png";